var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.choice === 1)?_c('Basic'):_vm._e(),(_vm.choice === 2)?_c('CreateAccount'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }